/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  QueryFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'



/**
 * Get all phone dial in options in a list
 */
export const utxCountriesGetPhoneDailInList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/countries/phone-dail-in-list`,options
    );
  }


export const getUtxCountriesGetPhoneDailInListQueryKey = () => [`/countries/phone-dail-in-list`];

    
export type UtxCountriesGetPhoneDailInListQueryResult = NonNullable<Awaited<ReturnType<typeof utxCountriesGetPhoneDailInList>>>
export type UtxCountriesGetPhoneDailInListQueryError = AxiosError<unknown>

export const useUtxCountriesGetPhoneDailInList = <TData = Awaited<ReturnType<typeof utxCountriesGetPhoneDailInList>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCountriesGetPhoneDailInList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCountriesGetPhoneDailInListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCountriesGetPhoneDailInList>>> = ({ signal }) => utxCountriesGetPhoneDailInList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCountriesGetPhoneDailInList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCountriesGetNationality = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/countries/nationality`,options
    );
  }


export const getUtxCountriesGetNationalityQueryKey = () => [`/countries/nationality`];

    
export type UtxCountriesGetNationalityQueryResult = NonNullable<Awaited<ReturnType<typeof utxCountriesGetNationality>>>
export type UtxCountriesGetNationalityQueryError = AxiosError<unknown>

export const useUtxCountriesGetNationality = <TData = Awaited<ReturnType<typeof utxCountriesGetNationality>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCountriesGetNationality>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCountriesGetNationalityQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCountriesGetNationality>>> = ({ signal }) => utxCountriesGetNationality({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCountriesGetNationality>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get all countries code in options in a list
 */
export const utxCountriesGetCountryCode = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/countries/countries-code`,options
    );
  }


export const getUtxCountriesGetCountryCodeQueryKey = () => [`/countries/countries-code`];

    
export type UtxCountriesGetCountryCodeQueryResult = NonNullable<Awaited<ReturnType<typeof utxCountriesGetCountryCode>>>
export type UtxCountriesGetCountryCodeQueryError = AxiosError<unknown>

export const useUtxCountriesGetCountryCode = <TData = Awaited<ReturnType<typeof utxCountriesGetCountryCode>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCountriesGetCountryCode>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCountriesGetCountryCodeQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCountriesGetCountryCode>>> = ({ signal }) => utxCountriesGetCountryCode({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCountriesGetCountryCode>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Get all countries risk in a list
 */
export const utxCountriesGetCountryRisks = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/countries/countries-risks`,options
    );
  }


export const getUtxCountriesGetCountryRisksQueryKey = () => [`/countries/countries-risks`];

    
export type UtxCountriesGetCountryRisksQueryResult = NonNullable<Awaited<ReturnType<typeof utxCountriesGetCountryRisks>>>
export type UtxCountriesGetCountryRisksQueryError = AxiosError<unknown>

export const useUtxCountriesGetCountryRisks = <TData = Awaited<ReturnType<typeof utxCountriesGetCountryRisks>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCountriesGetCountryRisks>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCountriesGetCountryRisksQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCountriesGetCountryRisks>>> = ({ signal }) => utxCountriesGetCountryRisks({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCountriesGetCountryRisks>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxCountriesGetCountryRisksByCode = (
    code: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.get(
      `/countries/countries-risks/${code}`,options
    );
  }


export const getUtxCountriesGetCountryRisksByCodeQueryKey = (code: string,) => [`/countries/countries-risks/${code}`];

    
export type UtxCountriesGetCountryRisksByCodeQueryResult = NonNullable<Awaited<ReturnType<typeof utxCountriesGetCountryRisksByCode>>>
export type UtxCountriesGetCountryRisksByCodeQueryError = AxiosError<unknown>

export const useUtxCountriesGetCountryRisksByCode = <TData = Awaited<ReturnType<typeof utxCountriesGetCountryRisksByCode>>, TError = AxiosError<unknown>>(
 code: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxCountriesGetCountryRisksByCode>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxCountriesGetCountryRisksByCodeQueryKey(code);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxCountriesGetCountryRisksByCode>>> = ({ signal }) => utxCountriesGetCountryRisksByCode(code, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxCountriesGetCountryRisksByCode>>, TError, TData>(queryKey, queryFn, {enabled: !!(code), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

